var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "iframe-container",
      class: { allScreen: _vm.isAllScreen },
      style: { "min-height": _vm.clientHeight },
    },
    [
      _c("iframe", {
        staticClass: "iframe-wrap",
        attrs: { id: "iframe", src: _vm.url, title: _vm.$route.meta.name },
        on: { load: _vm.onload },
      }),
      _vm.showHandler
        ? _c(
            "handleIcon",
            {
              attrs: { isAllScreen: _vm.isAllScreen },
              on: {
                allScreen: function ($event) {
                  return _vm.toggleAllScreenFull(!_vm.isAllScreen)
                },
              },
            },
            [
              _c("template", { slot: "menu" }, [
                _vm.isBigScreen
                  ? _c("li", { on: { click: _vm.onNewTab } }, [
                      _c("div", { staticClass: "icon" }, [
                        _c("i", { staticClass: "iconfont iconlianjie" }),
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("dashboard-bi::default-board::新窗口打开")
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }